import React from "react"
import { Navigate } from "react-router-dom"

export const NotFound = () => {
    return(
        <Navigate to="/" />
    )
}

export default function NoDataFound({msg}){

    return(
    <div style={{display:'flex',justifyContent:'center',alignItems: 'center'}}>
        {msg}
    </div>
    )

}
 